import { Observable } from 'rxjs/Observable';
import { Component, Output, EventEmitter, Input, OnInit, OnDestroy } from '@angular/core';

import { UploadService } from '../shared/upload.service';

import { Upload } from '../shared/upload';

@Component({
  selector: 'app-upload-form',
  templateUrl: './upload-form.component.html',
  styleUrls: ['./upload-form.component.scss'],
})
export class UploadFormComponent implements OnInit, OnDestroy {

  @Input() uploadText: string;
  @Input() mode: string;
  @Input() fontMode:boolean = false;
  @Input() hideText: boolean = false;
  @Output() itemUploaded: EventEmitter<string>;
  @Output() profilePicUploaded: EventEmitter<string>;
  @Output() itemUploading: EventEmitter<boolean>;

  selectedFiles: FileList | null;
  currentUpload: Upload;
  imageObsvervable: Observable<any>;
  target = "";

  constructor(private uploadService: UploadService) {
    this.itemUploaded = new EventEmitter<string>();
    this.profilePicUploaded = new EventEmitter<string>();
    this.itemUploading = new EventEmitter<boolean>(false);

  }

  ngOnInit(): void {
    this.imageObsvervable = this.uploadService.uploadedImageObservable;
    if (this.imageObsvervable) {
      this.imageObsvervable.subscribe(imageUrl => {
        if (imageUrl) {
          
          const isUploadHeaderOpen = document.getElementById("header-image-selector");
          if (this.mode && this.mode == "profile" && this.target == "profile" && !isUploadHeaderOpen) {
            this.itemUploaded.emit(imageUrl + '&mode=profile');
            this.currentUpload = null;
          } else {
            this.itemUploaded.emit(imageUrl);
            this.currentUpload = null;
          }
          this.uploadService.pushUpload(null);
        }
      });
    }

  }

  ngOnDestroy(): void {
    this.imageObsvervable = null;
  }

  detectFiles($event: Event) {
       
    this.target = ($event.target as any).parentElement.parentElement.id;
    this.selectedFiles = ($event.target as HTMLInputElement).files;
    this.uploadSingle();

  }
  // init() {
  //   this.currentUpload = new Upload();
  //   document.getElementById("file_input_id").click();
  // }


  uploadSingle() {

    const file = this.selectedFiles;
    if (file && file.length === 1) {
      const body = document.getElementsByTagName('body')[0];
      body.style.overflow = "hidden";


      this.currentUpload = new Upload();
      this.itemUploading.emit(true);
      this.currentUpload.file = file.item(0);
      this.uploadService.pushUpload(this.currentUpload, this.fontMode);


    } else {
      console.error('No file found!');
    }
  }

  uploadMulti() {
    const files = this.selectedFiles;
    if (!files || files.length === 0) {
      console.error('No Multi Files found!');
      return;
    }

    Array.from(files).forEach((file) => {
      this.currentUpload = new Upload();
      this.currentUpload.file = file;
      this.uploadService.pushUpload(this.currentUpload);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/uploads/upload-form/upload-form.component.ts